/* ============================================================
   MAUNA - el boton de comprar.

   Reemplaza al boton acelerado de PayPal, que era amarillo y no
   se podia repintar porque el color, la forma y el logo son marca
   de PayPal y Shopify no expone nada para cambiarlos.

   Lo que hace: agrega la variante al carrito y manda al checkout.

   Los ganchos se llaman data-mauna-buy y no data-mnc porque .mnc
   ya era el bloque del cajon del carrito. Ver la nota larga en
   assets/mauna-comprar.css.

   DIFERENCIA CON EL BOTON DE SHOPIFY, Y HAY QUE SABERLA.
   El de Shopify compraba SOLO ese objeto, saltandose el carrito.
   Este agrega al carrito y luego va al checkout, asi que si el
   cliente ya tenia algo dentro, se lleva las dos cosas. No hay
   sorpresa de cobro: el checkout muestra el pedido completo antes
   de pagar. Se eligio asi porque la alternativa (el enlace
   /cart/VARIANTE:CANTIDAD) borra el carrito que el cliente ya
   tenia, y perder lo que alguien ya eligio es peor que sumarlo.

   Si /cart/add.js falla, el boton vuelve a su estado y aparece un
   aviso debajo. No se manda al checkout a ciegas: llegar a un
   checkout vacio es peor que quedarse en la ficha.
   ============================================================ */

(function () {
  'use strict';

  var BUSY = 'data-mauna-buy-busy';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var btn = target.closest('[data-mauna-buy]');
    if (!btn) return;

    event.preventDefault();
    if (btn.hasAttribute(BUSY)) return;

    var form =
      btn.closest('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    var wrap = btn.closest('.mauna-buy-wrap');
    var err = wrap ? wrap.querySelector('[data-mauna-buy-err]') : null;
    var label = btn.querySelector('[data-mauna-buy-label]') || btn;
    var original = label.textContent;

    function fail() {
      btn.removeAttribute(BUSY);
      btn.disabled = false;
      label.textContent = original;
      if (err) err.hidden = false;
    }

    if (!form) {
      fail();
      return;
    }

    // Se lee al hacer clic, no al cargar: el id cambia cada vez que
    // el cliente toca una talla o un color.
    var idInput = form.querySelector('[name="id"]');
    var id = idInput && idInput.value;
    if (!id) {
      fail();
      return;
    }

    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = parseInt(qtyInput && qtyInput.value, 10);
    if (!quantity || quantity < 1) quantity = 1;

    btn.setAttribute(BUSY, '');
    btn.disabled = true;
    label.textContent = 'One moment';
    if (err) err.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add respondio ' + res.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        fail();
      });
  });
})();